import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.props.isActive)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g({},on),[_c(VIcon,{attrs:{"small":""}},[_vm._v("\n        mdi-credit-card-off-outline\n      ")])],1)]}}],null,false,217738401)},[_c('span',[_vm._v(_vm._s(_setup.t("card_state_inactive")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }